import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";

// Options
const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "Admin", value: "Admin" },
  { label: "STORE", value: "STORE" },
  { label: "IED", value: "IED" },
  { label: "PACKING", value: "PACKING" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "QUALITY", value: "QUALITY" },
  { label: "ANCILLARY", value: "ANCILLARY" },
  { label: "EMBROIDERY", value: "EMBROIDERY" },
];

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const typeOptions = [
  { label: "On Duty", value: "On Duty" },
  { label: "Permission", value: "Permission" }
];

const statusOptions = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Pending", value: "Pending" },
];

const data = [
  { slipNo: "1", code: "001", name: "ARUN", date: "30.04.24", sTime: "14:50", eTime: "15:50", remarks: "test", status: "Approved", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
  { slipNo: "15", code: "001", name: "ARUN", date: "01.07.24", sTime: "09:00", eTime: "18:00", remarks: "test", status: "Rejected", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
  { slipNo: "104", code: "001", name: "ARUN", date: "02.08.24", sTime: "09:09", eTime: "21:09", remarks: "Test", status: "Pending", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
  { slipNo: "105", code: "001", name: "ARUN", date: "05.08.24", sTime: "07:00", eTime: "21:00", remarks: "Test", status: "Pending", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
  { slipNo: "113", code: "001", name: "ARUN", date: "05.12.24", sTime: "06:00", eTime: "18:00", remarks: "Went Client Place", status: "Pending", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
  { slipNo: "5", code: "002", name: "VIGNESH", date: "04.03.24", sTime: "14:00", eTime: "15:59", remarks: "System Generated - Converted from Absent List", status: "Approved", approvedBy: "AES ADMIN", createdBy: "AES ADMIN" },
];

// Columns
const columns = [
  { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  { Header: "Slip#", accessor: "slipNo" },
  { Header: "Code", accessor: "code" },
  { Header: "Employee Name", accessor: "name" },
  { Header: "Date", accessor: "date" },
  { Header: "S.Time", accessor: "sTime" },
  { Header: "E.Time", accessor: "eTime" },
  { Header: "Remarks", accessor: "remarks" },
  { Header: "Status", accessor: "status",},
  { Header: "Approved By", accessor: "approvedBy" },
  { Header: "Created By", accessor: "createdBy" },
];

const AttendanceReportPermissionOD = () => {
  const [authDetails, setAuthDetails] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0]);
  }, []);

  const formik = useFormik({
    initialValues: {
      department: null,
      category: null,
      type: null,
      fromDate: "",
      toDate: "",
      code: "",
      name: "",
      slipNo: "",
      status: null,
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().required("From Date is required"),
      toDate: Yup.string().required("To Date is required"),
      type: Yup.object({
        value: Yup.string().required("Type is required")
      }).nullable().required("Type is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  useEffect(() => {
    if (authDetails) {
      getAttendanceSalaryDate(authDetails.unit_id).then(response => {
        if (response.status === "success" && response.data.length > 0) {
          const data = response.data[0];
          formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
          formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
        }
      });
    }
  }, [authDetails]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Permission & OD" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Type <span className="text-danger">*</span></Label>
                  <CustomSelect
                    name="type"
                    value={formik.values.type}
                    onChange={(val) => formik.setFieldValue("type", val)}
                    options={typeOptions}
                    placeholder="--Select--"
                  />
                  {formik.touched.type && formik.errors.type ? (
                    <div className="text-danger">{formik.errors.type.value || formik.errors.type}</div>
                  ) : null}
                </Col>
                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>From Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate ? (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  ) : null}
                </Col>
                <Col md={4}>
                  <Label>To Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate ? (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  ) : null}
                </Col>
                <Col md={4}>
                  <Label>Code</Label>
                  <input
                    type="text"
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>
                <Col md={4}>
                  <Label>Name</Label>
                  <input
                    type="text"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>
                <Col md={4}>
                  <Label>Slip #</Label>
                  <input
                    type="text"
                    name="slipNo"
                    value={formik.values.slipNo}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>
                <Col md={4}>
                  <Label>Status</Label>
                  <CustomSelect
                    name="status"
                    value={formik.values.status}
                    onChange={(val) => formik.setFieldValue("status", val)}
                    options={statusOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={12} className="d-flex align-items-end justify-content-end gap-2 flex-wrap">
                  <Button type="submit" className="btn button-search "><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print "><i className="fas fa-print me-1 " /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportPermissionOD;
